import React from 'react'

export default function Case(props) {
  return (
    <div className={'case-box' + props.id}>
        <img className='case-img' src={props.img} alt={'case-img' + props.id}/>
        <div className='case-desc'>
            <h4>{props.title}</h4>
            <p>{props.text}</p>
        </div>
    </div>
  )
}
